import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import WebCoordinators from './pages/WebCoordinators';
import LoginLogs from './pages/LoginLogs';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './layout/AdminLayout';

// Academics
import FacultyInformation from './pages/academics/FacultyInformation';
import AcademicCalendar from './pages/academics/AcademicCalendar';

// Admissions
import AdmissionFAQs from './pages/admissions/AdmissionFAQs';
import BrochureDownloads from './pages/admissions/BrochureDownloads';

// Placement
import TopRecruiters from './pages/placement/TopRecruiters';

// Examinations
import NoticesCirculars from './pages/examinations/NoticesCirculars';
import ExamTimetables from './pages/examinations/ExamTimetables';

// Media
import AlumniSpeak from './pages/media/AlumniSpeak';
import LatestNews from './pages/media/LatestNews';
import AcademicNews from './pages/media/AcademicNews';
import AdmissionsNews from './pages/media/AdmissionsNews';
import StudentTestimonials from './pages/media/StudentTestimonials';
import ManetBlogs from './pages/media/ManetBlogs';

// Applications
import ContactUs from './pages/applications/ContactUs';
import EnquireNow from './pages/applications/EnquireNow';
import PlacedStudents from './pages/placement/PlacedStudents';
import Gallery from './pages/media/Gallery';

const AppAdmin = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        
        {/* Academics */}
        <Route path="academics/faculty-information" element={<FacultyInformation />} />
        <Route path="academics/academic-calendar" element={<AcademicCalendar />} />
        
        {/* Admissions */}
        <Route path="admissions/faqs" element={<AdmissionFAQs />} />
        <Route path="applications/brochure-downloads" element={<BrochureDownloads />} />
        
        {/* Placement */}
        <Route path="placement/top-recruiters" element={<TopRecruiters />} />
        <Route path="placement/placed-students" element={<PlacedStudents />} />
        
        {/* Examinations */}
        <Route path="examinations/notices-circulars" element={<NoticesCirculars />} />
        <Route path="examinations/exam-timetables" element={<ExamTimetables />} />
        
        {/* Media */}
        <Route path="media/alumni-speak" element={<AlumniSpeak />} />
        <Route path="media/latest-news" element={<LatestNews />} />
        <Route path="media/academic-news" element={<AcademicNews />} />
        <Route path="media/admissions-news" element={<AdmissionsNews />} />
        <Route path="media/student-testimonials" element={<StudentTestimonials />} />
        <Route path="media/manet-blogs" element={<ManetBlogs />} />
        <Route path="media/gallery" element={<Gallery />} />
        
        {/* Applications */}
        <Route path="applications/contact-us" element={<ContactUs />} />
        <Route path="applications/enquire-now" element={<EnquireNow />} />
        
        {/* Superadmin only - unchanged */}
        <Route path="web-coordinators" element={<WebCoordinators />} />
        <Route path="login-logs" element={<LoginLogs />} />
      </Route>
    </Routes>
  );
};

export default AppAdmin;
